module.exports = __webpack_public_path__ + "vue/img/new_facility_1.14c675a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intro/new_facility_1.png
// module id = Icq1
// module chunks = 1